import React, { useEffect } from "react";
import io from "socket.io-client";
import has from "lodash/has";
import { useSelector, useDispatch } from "react-redux";
import Notification from "components/Notification";
import {
  getTree,
  clearSelectedFile,
  resetHttpStatus
} from "store/actions/fileAction";
import { MiniInfoBar } from "./MiniInfoBar";
import { UPLOAD_DOCS_TO_ADAPTER } from "helpers/permissions.json";
import { SpinnerRainbow } from "components/Spinner";
import Translate from "helpers/Translate";

export const DocumentBar = () => {
  const dispatch = useDispatch();
  const fileInfo = useSelector(state => state.file.getFile);
  const pdfSampleFileName = useSelector(state => state.file.pdfSampleFileName);
  const isLoadingFile = useSelector(state => state.file.isLoadingFile);
  const updateFileResponseStatus = useSelector(state => state.file.httpStatus);
  const permissions = useSelector(state => state.role.getPermissions);
  const fileStatus = useSelector(state => state.file.getActiveTab);
  const selectedClient = useSelector(state => state.client.selectedClient);
  const selectedSubordinate = useSelector(state => state.file.getSubordinate);

  // Show socket.io notifications
  useEffect(() => {
    const socket = io(process.env.REACT_APP_PUBLIC_URL, {
      transports:
        process.env.NODE_ENV === "development" ? ["polling"] : ["websocket"]
    });
    let loggedUser;

    try {
      loggedUser = JSON.parse(localStorage.getItem("logged_user"));
      if (loggedUser) {
        socket.on(`automatic_file_submissions_${loggedUser.id}`, message => {
          Notification.info(message, { forceDelay: 60 });
        });
      }
    } catch (error) {}
  }, []);

  // When form submissions is success
  useEffect(() => {
    if (updateFileResponseStatus === 200 && fileStatus && selectedClient) {
      dispatch(resetHttpStatus());
      dispatch(clearSelectedFile());
      dispatch(
        getTree({
          client: selectedClient,
          fileStatus,
          subordinateId: selectedSubordinate?.id || ""
        })
      );

      // Show appropiate notification message
      if (permissions && permissions.includes(UPLOAD_DOCS_TO_ADAPTER)) {
        Notification.success(
          Translate({
            id: "files_are_now_ready_to_upload_initiate_a_new_upload_job_from_the_upload_logs_menu"
          }),
          { delay: 6 }
        );
      } else {
        Notification.success(Translate({ id: "files_updated_successfully" }));
      }
    }
    // eslint-disable-next-line
  }, [updateFileResponseStatus, selectedClient, fileStatus, dispatch]);

  return (
    <div className="document-bar">
      {/* Loader */}
      {isLoadingFile ? (
        <SpinnerRainbow />
      ) : (
        <>
          <MiniInfoBar />
          {(pdfSampleFileName || has(fileInfo, "id")) && (
            <iframe
              title={has(fileInfo, "id") ? fileInfo.id : "test"}
              style={{ width: "100%", height: "100%", border: "0" }}
              src={
                has(fileInfo, "signed_url")
                  ? fileInfo.signed_url
                  : `${process.env.REACT_APP_PUBLIC_URL}/pdf/${pdfSampleFileName}`
              }
            />
          )}
        </>
      )}
    </div>
  );
};

export default DocumentBar;
